import { ItemTabs } from 'CMFW/layout/ItemTabs';
import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import TranslationBank from '../AgentQA/tabs/TranslationBank';
import MemoryMain from './tabs/MemoryMain';
import MemoryPhrasebook from './tabs/MemoryPhrasebook';
import MemorySemanticUnifier from './tabs/MemorySemanticUnifier';
import MemoryPatternFrequency from './tabs/MemoryPatternFrequency';
import MemoryPatternConsistency from './tabs/MemoryPatternConsistency';
import MeansTemplateSets from './components/MeansTemplateSets';
import { IRefIds } from '../../constants/refs';

export type IProps = {
  search?: string;
  dialect?: string;
  subModuleId?: number;
};

const Memory: React.FC<IProps> = (props) => {
  const showPhrasebook = props.subModuleId === IRefIds.memoryPhrasebook;
  return (
    <ModuleContainer>
      <ItemTabs
        tabNames={[
          'Reference Bank',
          'Phrasebook',
          'Means Template Sets',
          'Memory',
          'Pattern Frequency',
          'Pattern Consistency',
          'Semantic Unifier',
        ]}
        showTabIndex={showPhrasebook ? 1 : 0}
      >
        <TranslationBank isPreset={true} />
        <MemoryPhrasebook searchText={showPhrasebook ? props.search : undefined} />
        <MeansTemplateSets />
        <MemoryMain
          search={!showPhrasebook ? props.search : undefined}
          dialect={!showPhrasebook ? props.dialect : undefined}
        />
        <MemoryPatternFrequency />
        <MemoryPatternConsistency />
        <MemorySemanticUnifier />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default Memory;
